import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";

export default function Dispatch() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/orders").then(r => setItems(r.data.filter(o => ["ready","customization","dispatched"].includes(o.stage)))); }, []);
  return (
    <div className="space-y-6">
      <div>
        <div className="label-tiny mb-1">Dispatch queue</div>
        <h1 className="font-display text-3xl tracking-tight">Ready for QC & Ship</h1>
      </div>
      <div className="card-surface overflow-x-auto">
        <table className="data-table">
          <thead><tr><th>Order #</th><th>Customer</th><th>Stage</th><th>QC</th><th>Courier</th><th></th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="p-6 text-center text-[#757169]">Nothing in dispatch queue.</td></tr>}
            {items.map(o => (
              <tr key={o.id}>
                <td className="mono">{o.order_no}</td>
                <td>{o.customer_name}</td>
                <td><span className="badge badge-warn">{o.stage}</span></td>
                <td>{o.dispatch?.qc_done ? "✓" : "—"}</td>
                <td>{o.dispatch?.courier||"—"}</td>
                <td><Link className="btn-ghost text-xs" to={`/orders/${o.id}`}>Open →</Link></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
